var _rect, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWomen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_1433)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 100,
    fill: "url(#paint0_linear_4_1433)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.1953 139.249C87.9689 129.649 101.224 111.248 132.787 85.3919C180.413 46.3753 135.463 10.6881 87.1738 29.695C82.0081 31.7285 67.6933 23.5879 54.4333 32.1641C45.8796 37.6964 49.2085 42.032 45.8778 46.3676C42.5472 50.7033 29.7066 50.4481 26.8936 61.7061C25.2276 68.3759 29.8379 75.3623 29.2213 80.3825C28.6046 85.4027 23.7377 89.928 23.5055 96.5553C23.405 99.3545 23.8569 102.146 24.8354 104.77C25.8139 107.395 27.2998 109.801 29.2083 111.851C31.1169 113.901 33.4105 115.555 35.9584 116.719C38.5063 117.882 41.2584 118.532 44.0575 118.632C44.0804 124.166 46.2411 129.477 50.0881 133.455C53.9351 137.432 59.1707 139.77 64.7006 139.977C68.2464 140.107 71.7681 139.344 74.9426 137.759C78.0923 140.662 80.7962 141.575 82.1953 139.249Z",
    fill: "url(#paint1_linear_4_1433)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94 27.3333C85.7893 32.6 75.6313 49.8733 80.09 73.0606C81.0626 78.12 78.0233 79.6346 75.4233 73.394C67.5786 54.5666 66.6693 37.5873 80.09 29.4653C82.4233 28.0606 83.7566 29.1986 85.4233 29.0606C88.5933 28.798 92.8613 26.552 94 27.3333Z",
    fill: "url(#paint2_linear_4_1433)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3333 129.333C83.3333 123.333 83.1293 93.7386 83.1393 93.2386C66.6666 95.6666 67 64.3333 83.6666 72C87.3333 74.3333 97.6666 72 96.6666 52.6666C114.667 72 135.565 49.4506 137.357 67.8253C139.804 92.9153 137.342 119.173 121.749 119.175C120.044 119.154 118.343 118.984 116.667 118.667V129.333C116.667 136 128.667 139.333 128.667 139.333C128.667 139.333 107.939 158.867 99.3333 158.759C90.728 158.651 71.3333 139.333 71.3333 139.333C71.3333 139.333 83.3333 136 83.3333 129.333Z",
    fill: "url(#paint3_linear_4_1433)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.666 118.663C108.396 116.829 100.558 113.411 93.5869 108.597C93.5869 108.597 99.339 122.659 116.645 125.327L116.666 118.663Z",
    fill: "#FFDBC9"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161.333 159.333C166.17 170.081 168.667 202.667 168.667 202.667H31.3333C31.3333 202.667 33.8299 170.081 38.6666 159.333C42.9039 149.918 70.8259 139.107 79.0086 136C83.7332 141.285 90.5039 144.667 99.9999 144.667C109.496 144.667 116.267 141.285 120.991 136C129.174 139.107 157.096 149.918 161.333 159.333Z",
    fill: "url(#paint4_linear_4_1433)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_1433",
    x1: 100,
    y1: 200,
    x2: 100,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD2C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_1433",
    x1: 85.971,
    y1: 140.777,
    x2: 90.0776,
    y2: 23.5607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6864E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67240"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_1433",
    x1: 81.8596,
    y1: 27.1691,
    x2: 81.8596,
    y2: 77.4929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D0024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_1433",
    x1: 104.573,
    y1: 52.6666,
    x2: 104.573,
    y2: 158.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEADB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4_1433",
    x1: 99.9999,
    y1: 136,
    x2: 99.9999,
    y2: 202.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#130027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130017"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_1433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomen);
export default __webpack_public_path__ + "static/media/women.a4e5e7965457f200f68c544ce50275cf.svg";
export { ForwardRef as ReactComponent };